import { ApiClient } from '@/services/api.service';
import { Lang, SearchParamsLangs } from './types';

class LangApi {
    async getLangs(params: SearchParamsLangs): Promise<any> {
        const data = await ApiClient.get<Lang[]>('/languages/', { params })
        return data
    }
}

export const langApi = new LangApi()
